import React from 'react';
import './plaementsCard.css'

function C2wPlacementCard( { onClick, index, url} ) {
  return (
    <div className='C2wPlacementCard_ctn'  onClick={onClick}>
        <img className='C2wPlacementCard_ctn_img'  src={url} alt={'student-img'} />
    </div>
  )
}

export default C2wPlacementCard;
